import { Route, Routes } from "react-router-dom"
import Main from "./(pages)/main/page"

const HomeRide = () => {
  return (
    <Routes>
        <Route path="*" element={<Main />}/>
    </Routes>
  )
}

export default HomeRide